<template>
  <div class="outBox">
    <el-row :gutter="20">
      <el-col :span="8">
        <div class="grid-content bg-purple">
          <!-- 首页user信息 -->
          <el-card shadow="hover">
            <p class="important-font">{{ personInfo.name }}</p>
            <el-select
              size="small"
              v-model="storeId"
              placeholder="请选择门店"
              @change="changeStore"
            >
              <el-option
                v-for="type in storeList"
                :label="type.key"
                :value="type.value"
                :key="type.value"
              ></el-option>
            </el-select>
          </el-card>
          <!-- 首页表格 -->
          <el-card shadow="hover" class="tableInfo">
            <div class="selectTimeBox">
              <el-date-picker
                v-model="temValue"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="selectTemTime"
              >
              </el-date-picker>

              <el-button
                size="small"
                type="primary"
                icon="el-icon-upload2"
                @click="exportGoods"
                >导出</el-button
              >
            </div>
            <div slot="header">
              <span class="important-font">单品销量</span>
            </div>
            <div>
              <el-table
                :data="TenMessage"
                stripe
                border
                height="580px"
                style="width: 100%"
              >
                <el-table-column label="排名" width="60">
                  <template slot-scope="scope">{{ scope.$index + 1 }}</template>
                </el-table-column>
                <el-table-column prop="name" label="商品名" width="180">
                </el-table-column>
                <el-table-column prop="num" label="销量" width="80">
                </el-table-column>
                <el-table-column prop="salePrice" label="零售价">
                </el-table-column>
              </el-table>
            </div>
          </el-card>
        </div>
      </el-col>
      <el-col :span="16">
        <!-- 六个订单信息 -->
        <div class="num">
          <el-card
            shadow="hover"
            v-for="item in countData"
            :key="item.name"
            :body-style="{ display: 'flex', padding: 0 }"
            class="OrderCard"
          >
            <i
              class="icon"
              :class="'el-icon-' + item.icon"
              :style="{ background: item.color }"
            ></i>
            <div class="textBox">
              <p class="important-font">{{ item.value }}</p>
              <p class="secondary-font">{{ item.name }}</p>
            </div>
          </el-card>
        </div>
        <!-- 柱状图 -->
        <el-card style="">
          <div class="selectTime">
            <el-date-picker
              v-model="goodValue"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="selectGoodTime"
            >
            </el-date-picker>
            <el-button
              size="small"
              type="primary"
              icon="el-icon-upload2"
              @click="exportSales"
              >导出</el-button
            >
          </div>
          <div style="height: 380px" ref="barEcharts">
            {{ initBarEcharts() }}
          </div>
        </el-card>
        <!-- <div class="num graph">
          <el-card style="width: 34%; height: 265px; marginright: 1%">
            <div style="width: 100%; height: 265px" ref="pieEcharts">
              {{ initPieEcharts() }}
            </div>
          </el-card>
          <el-card style="width: 65%; height: 265px"
            ><div style="height: 265px">
              <el-calendar v-model="value"></el-calendar></div
          ></el-card>
        </div> -->
      </el-col>
    </el-row>
  </div>
</template>

  <script>
import * as echarts from "echarts";

import { blobValidate } from "@/utils/ruoyi";
import { saveAs } from "file-saver";


import { get } from "echarts/lib/CoordinateSystem";
import { Container } from "element-ui";
import {  getDayOrder,
  getPersonInfo,
  getGoodsSales, //获取商品销量
  getSingleGoodsSales,
  getStoreList
} from "../../api/api";

export default {
  // name: "Index",
  data() {
    return {
      // imgUrl:require('../assets/avatar.jpg'),

      storeList: [], //门店列表
      storeId: localStorage.getItem("storeId"), //门店id
      temValue: new Date(),
      goodValue: new Date(),
      temStartTime: "", //单品开始时间
      temEndTime: "", //单品结束时间
      goodStartTime: "", //商品开始时间
      goodEndTime: "", //商品结束时间
      tableData: [],
      countData: [
        {
          name: "今日支付订单",
          value: '',
          icon: "success",
          color: "#2ec7c9",
        },
        {
          name: "今日营业额",
          value: '',
          icon: "star-on",
          color: "#ffb980",
        },
        {
          name: "今日利润",
          value: '',
          icon: "s-goods",
          color: "#5ab1ef",
        },
        {
          name: "昨日订单",
          value: '',
          icon: "success",
          color: "#2ec7c9",
        },
        {
          name: "昨日营业额",
          value: '',
          icon: "star-on",
          color: "#ffb980",
        },
        {
          name: "昨日利润",
          value: '',
          icon: "s-goods",
          color: "#5ab1ef",
        },
      ],
      personInfo: {}, //用户信息
      GoodMessage: [], //商品销量
      TenMessage: [], //单品销量

      option: {
        title: {
          text: "销售表",
        },
        tooltip: {},
        legend: {
          data: ["销售额", "利润"],
        },
        xAxis: {
          data: ["华为", "vivo", "oppo", "ipone", "小米", "三星", "dddd"],
        },
        yAxis: {},
        series: [
          {
            name: "销售额",
            type: "bar",
            data: [],
          },
          {
            name: "利润",
            type: "bar",
            data: [],
          },
        ],
      },
    };
  },
  created() {
    //获取门店列表
    this.storeId = Number(localStorage.getItem("storeId"));
    this.storeList = JSON.parse(localStorage.getItem("storeLitst"));

    this.getStoreLists();
    //获取当前时间，转化成day: 10 month: 10  year: 2023

  },
  methods: {
    //获取门店列表
    getStoreLists() {
      getStoreList().then((res) => {
        // this.storeList = res.data;
        //改变数组里元素的某个属性
        res.data.forEach((item) => {
          item.key = item.name;
          item.value = item.id;
        });
        this.storeList = res.data;
        localStorage.setItem("storeLitst", JSON.stringify(res.data));
        if(localStorage.getItem("storeId") == null){
          localStorage.setItem("storeId", res.data[0].id);
          this.storeId = res.data[0].id;

        }


        let date = new Date();
        //获取本月的1号
        let firstDate = new Date().setDate(1);
        this.temValue = [firstDate, new Date()];
        this.goodValue = [firstDate, new Date()];
        this.getTodayData(date);
        this.getYesterdayData(date);
        this.getUserInfo(); //获取用户信息
        this.getGoodsSaleList(this.temValue); //获取商品销量
        this.getSingleGoodsSales(this.temValue); //获取单品销量
      });
    },
    //修改门店
    changeStore(e) {
      localStorage.setItem("storeId", e);
      this.storeId = e;
      let date = new Date();
      // this.temValue = date;
      // this.goodValue = date;
      this.getTodayData(date);
      this.getYesterdayData(date);
      this.getUserInfo(); //获取用户信息
      this.getGoodsSaleList(this.goodValue); //获取商品销量
      this.getSingleGoodsSales(this.temValue); //获取单品销量
      // this.initBarEcharts();
    },
    //选择时间
    selectTemTime(time) {
      //获取当前时间，转化成day: 10 month: 10  year: 2023
      //把startTime和endTime转化成2023-10-13 这样的格式
      // newTime= startTime.getMonth()
      let data1 = new Date(time[0]);
      let data2 = new Date(time[1]);
      this.temStartTime =
        data1.getFullYear() +
        "-" +
        ("0" + (data1.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + data1.getDate()).slice(-2);
      this.temEndTime =
        data2.getFullYear() +
        "-" +
        ("0" + (data2.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + data2.getDate()).slice(-2);
      // console.log(startTime);
      //发请求获取数据
      getSingleGoodsSales({
        startTime: this.temStartTime,
        endTime: this.temEndTime,
        storeId: localStorage.getItem("storeId"),
      }).then((res) => {
        //把所有数组合并到一个数组
        let arr = [];
        res.data.storeGoodsMap.forEach((item) => {
          arr.push(item);
        });
        this.TenMessage = arr;
      });
      // let date = new Date(this.value[1]);
      // this.getTodayData(date);
      // this.getYesterdayData(date);
      // this.getGoodsSaleList(date); //获取商品销量
      // this.getSingleGoodsSales(date); //获取单品销量
    },
    //选择商品销量时间
    selectGoodTime(time) {
      //获取当前时间，转化成day: 10 month: 10  year: 2023
      //把startTime和endTime转化成2023-10-13 这样的格式
      // newTime= startTime.getMonth()
      // this.initBarEcharts();
      this.option.series[0].data = [];
      this.option.series[1].data = [];
      let data1 = new Date(time[0]);
      let data2 = new Date(time[1]);
      this.goodStartTime =
        data1.getFullYear() +
        "-" +
        ("0" + (data1.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + data1.getDate()).slice(-2);
      this.goodEndTime =
        data2.getFullYear() +
        "-" +
        ("0" + (data2.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + data2.getDate()).slice(-2);
      // console.log(startTime);
      //发请求获取数据
      getGoodsSales({
        startTime: this.goodStartTime,
        endTime: this.goodEndTime,
        storeId: localStorage.getItem("storeId"),
      }).then((res) => {
        this.GoodMessage = res.data.maplist;
        //把每一个数据的时间拿出来放到一个数组中
        let timeArr = [];
        res.data.maplist.forEach((item) => {
          //在2023-10-13 00:00:00这样的数据中，只取出10-13数字
          item.time =
            item.time.split("-")[1] +
            "-" +
            item.time.split("-")[2].split(" ")[0];
          //收集销售额数据
          // item.turnover = item.turnover+'元';

          this.option.series[0].data.push(item.turnover);
          //收集利润数据
          // item.profit = item.profit+'元';

          this.option.series[1].data.push(item.profit);
          timeArr.push(item.time);
        });
        this.option.xAxis.data = timeArr;
        this.initBarEcharts();
      });
    },
    //柱状图
    initBarEcharts() {
      // 新建一个promise对象
      let p = new Promise((resolve) => {
        resolve();
      });
      //然后异步执行echarts的初始化函数
      p.then(() => {
        //	此dom为echarts图标展示dom
        let myChart = echarts.init(this.$refs.barEcharts);
        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(this.option);
      });
    },
    //饼图
    initPieEcharts() {
      let p = new Promise((resolve) => {
        resolve();
      });
      //然后异步执行echarts的初始化函数
      p.then(() => {
        let myChart = echarts.init(this.$refs.pieEcharts);
        let option = {
          tooltip: {
            trigger: "item",
          },
          legend: {
            top: "0%",
            left: "left",
          },
          series: [
            {
              name: "订单信息",
              type: "pie",
              radius: ["20%", "65%"],
              avoidLabelOverlap: false,
              label: {
                show: false,
                position: "left",
              },
              labelLine: {
                show: false,
              },
              data: [
                { value: 1048, name: "成交订单量" },
                { value: 735, name: "退款订单量" },
                { value: 580, name: "浏览量" },
                { value: 484, name: "加购量" },
                { value: 300, name: "预购量" },
              ],
            },
          ],
        };
        myChart.setOption(option);
      });
    },
    //获取用户信息
    getUserInfo() {
      getPersonInfo({
        storeId: localStorage.getItem("storeId"),
      }).then((res) => {
        this.personInfo = res.data;
      });
    },
    //获取今日数据
    getTodayData(date) {
      let day = date.getDate();
      let month = date.getMonth() + 1;
      let year = date.getFullYear();
      getDayOrder({
        year: year,
        month: month,
        day: day,
        storeId: localStorage.getItem("storeId"),
      }).then((res) => {
        this.countData[0].value = res.data.totalOrderNum; //今日订单
        this.countData[1].value = "￥"+res.data.turnover; //今日营业额
        this.countData[2].value = "￥"+res.data.profit; //今日利润
      });
    },
    //获取昨天数据
    getYesterdayData(date) {
      date.setDate(date.getDate() - 1); // 减去1天
      let day = date.getDate();
      let month = date.getMonth() + 1;
      let year = date.getFullYear();
      getDayOrder({
        year,
        month,
        day,
        storeId: localStorage.getItem("storeId"),
      }).then((res) => {
        this.countData[3].value = res.data.totalOrderNum; //今日订单
        this.countData[4].value = "￥"+res.data.turnover; //今日营业额
        this.countData[5].value = "￥"+res.data.profit; //今日利润
      });
    },
    //获取商品销量
    getGoodsSaleList(data) {
      this.option.series[0].data = [];
      this.option.series[1].data = [];

      //获取当前时间
      // this.option.series[0].data = [];
      // this.option.series[1].data = [];
      let data1 = new Date(data[0]);
      let data2 = new Date(data[1]);
      this.goodStartTime =
        data1.getFullYear() +
        "-" +
        ("0" + (data1.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + data1.getDate()).slice(-2);
      this.goodEndTime =
        data2.getFullYear() +
        "-" +
        ("0" + (data2.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + data2.getDate()).slice(-2);
      getGoodsSales({
        startTime: this.goodStartTime,
        endTime: this.goodEndTime,
        storeId: localStorage.getItem("storeId"),
      }).then((res) => {
        this.GoodMessage = res.data.maplist;
        //把每一个数据的时间拿出来放到一个数组中
        let timeArr = [];
        res.data.maplist.forEach((item) => {
          //在2023-10-13 00:00:00这样的数据中，只取出10-13数字
          item.time =
            item.time.split("-")[1] +
            "-" +
            item.time.split("-")[2].split(" ")[0];
          //收集销售额数据
          // item.turnover = item.turnover+'元';
          this.option.series[0].data.push(item.turnover);
          //收集利润数据
          // item.profit = item.profit+'元';
          this.option.series[1].data.push(item.profit);
          timeArr.push(item.time);
        });
        this.option.xAxis.data = timeArr;
        this.initBarEcharts();
      });
    },
    //获取单品销量
    getSingleGoodsSales(date) {
      //获取当前时间
      let startDate = new Date(date[0]);
      let endDate = new Date(date[1]);
      this.temStartTime =
        startDate.getFullYear() +
        "-" +
        ("0" + (startDate.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + startDate.getDate()).slice(-2);
      this.temEndTime =
        endDate.getFullYear() +
        "-" +
        ("0" + (endDate.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + endDate.getDate()).slice(-2);
      getSingleGoodsSales({
        startTime: this.temStartTime,
        endTime: this.temEndTime,
        storeId: localStorage.getItem("storeId"),
      }).then((res) => {
        //把所有数组合并到一个数组
        let arr = [];
        res.data.storeGoodsMap.forEach((item) => {
          arr.push(item);
        });
        this.TenMessage = arr;
      });
    },

    //导出单品销量
    exportGoods() {
      console.log(this.temStartTime);
      console.log(this.temEndTime);
      this.$confirm("确定导出单品销量吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .get(
              `https://ht.wteam.club/api/store/ExportGoodsRankingsByDate?storeId=${localStorage.getItem(
                "storeId"
              )}&startTime=${this.temStartTime}&endTime=${this.temEndTime}`,
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                  "token": localStorage.getItem("token"),
                },
                responseType: "blob",
              }
            )
            .then(async (res) => {
              const isLogin = await blobValidate(res);
              if (res.status == 200) {
                if (isLogin) {
                  console.log(new Blob([res]));
                  const blob = new Blob([res.data]);
                  console.log("blob1111", blob);
                  saveAs(blob, `商品列表_${new Date().getTime()}.xlsx`);
                  this.$message({
                    type: "success",
                    message: "导出成功",
                  });
                } else {
                  const resText = await res.text();
                  const rspObj = JSON.parse(resText);
                  const errMsg =
                    errorCode[rspObj.code] ||
                    rspObj.msg ||
                    errorCode["default"];
                  this.$message.error(errMsg);
                }
                this.$modal.closeLoading();
              } else {
                this.$message.error("导出失败");
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消导出",
          });
        });
    },
    //导出销量
    exportSales() {
      console.log(this.temStartTime);
      console.log(this.temEndTime);
      this.$confirm("确定导出销量吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .get(
              `https://ht.wteam.club/api/store/ExportTenQuery?storeId=${localStorage.getItem("storeId")}&startTime=${this.goodStartTime}&endTime=${this.goodEndTime}`,
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                  "token": localStorage.getItem("token"),
                },
                responseType: "blob",
              }
            )
            .then(async (res) => {
              const isLogin = await blobValidate(res);
              if (res.status == 200) {
                if (isLogin) {
                  console.log(new Blob([res]));
                  const blob = new Blob([res.data]);
                  console.log("blob1111", blob);
                  saveAs(blob, `销量列表_${new Date().getTime()}.xlsx`);
                  this.$message({
                    type: "success",
                    message: "导出成功",
                  });
                } else {
                  const resText = await res.text();
                  const rspObj = JSON.parse(resText);
                  const errMsg =
                    errorCode[rspObj.code] ||
                    rspObj.msg ||
                    errorCode["default"];
                  this.$message.error(errMsg);
                }
                this.$modal.closeLoading();
              } else {
                this.$message.error("导出失败");
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消导出",
          });
        });
    },
  },
};
</script>

  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style  scoped>
.el-avatar {
  background-color: white;
  display: flex;
  justify-content: center;
  align-content: center;
}

.selectTime {
  margin-bottom: 20px;
}
.selectTimeBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.el-card__body {
  /* padding: px; */

  /* background-color: #f2f6fc !important; */
}
.userCard {
  height: 80px;

  display: flex;
  /* border-bottom: 2px solid #dcdfe6; */
  border-radius: 2px;
}
.userInfo {
  width: auto;
  padding: 0;
}
.important-font {
  font-weight: 900;
  font-size: 20px;
}
.secondary-font {
  color: #909399;
}
.third-font {
  font-weight: 500;
  font-size: 15px;
}
.login-info {
  height: 40px;
  text-align: left;
  color: #909399;
}
.tableInfo {
  margin: 20px 0 0 0;
}
.OrderCard {
  margin: 0 0 20px 30px;
  border: #dcdfe6 1px solid;
  border-radius: 10px;
  /* height: 80px; */
}
.icon {
  width: 30%;
  line-height: 100px;
  font-size: 30px;
  color: #fff;
  text-align: center;
}
.textBox {
  /* background-color: red; */
  width: 20vw;
  text-align: center;
}
.el-card {
  border: none;
}
.num {
  display: flex;
  flex-wrap: wrap;
}
.graph {
  margin: 15px 0 0 0;
}
.el-calendar {
  height: 265px;
}
</style>



// WEBPACK FOOTER //
// src/views/home/home.vue